import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromNews from '../reducers/news.reducer';
import * as fromRoot from '../../../store';
import { News } from '../../models';

export const getNewsItemsState = createSelector(fromFeature.getNewsState, (state: fromFeature.NewsState) => state.news);

export const getNewsEntities = createSelector(getNewsItemsState, fromNews.getNewsEntities);

export const getAllNews = createSelector(getNewsEntities, entities => {
  return Object.keys(entities).map(id => entities[+id]);
});

//  sort by newest date
export const getAllNewsOrdered = createSelector(getAllNews, news => {
  return news.sort((a, b) => {
    const dateA = new Date(a.publicationDate).getTime();
    const dateB = new Date(b.publicationDate).getTime();
    return dateB - dateA;
  });
});

export const getFeaturedNews = createSelector(getAllNews, news => {
  return news.filter(n => n.featured).slice(0, 1) ?? news.slice(0, 1);
});

export const getFeaturedNewsOrdered = createSelector(getAllNewsOrdered, news => {
  return news.filter(n => n.featured).slice(0, 1) ?? news.slice(0, 1);
});

export const getNewsLoading = createSelector(getNewsItemsState, fromNews.getNewsLoading);
export const getNewsLoaded = createSelector(getNewsItemsState, fromNews.getNewsLoaded);

export const getNewsOverviewLoading = createSelector(getNewsItemsState, fromNews.getNewsOverviewLoading);
export const getNewsOverviewLoaded = createSelector(getNewsItemsState, fromNews.getNewsOverviewLoaded);

export const getNewsPage = createSelector(getNewsItemsState, fromNews.getNewsPage);

export const getNewsError = createSelector(getNewsItemsState, fromNews.getNewsError);

export const getSelectedNews = createSelector(getNewsEntities, fromRoot.getRouterState, (entities, router): News => {
  return router.state && entities[+router.state.params?.['newsId'] || +router.state.data?.['newsId']];
});

export const getSelectedContentPageLoading = createSelector(getNewsLoading, fromRoot.getRouterState, (loading, router): boolean => {
  return router.state && loading.includes(+router.state.params?.['newsId'] || +router.state.data?.['newsId']);
});

export const getSelectedNewsLoaded = createSelector(getNewsLoaded, fromRoot.getRouterState, (loaded, router): boolean => {
  return router.state && loaded.includes(+router.state.params?.['newsId'] || +router.state.data?.['newsId']);
});
